import { Component, computed, inject, Input, Signal } from '@angular/core';
import { MenuService } from '../../../../../../services/components/menu.service';
import { MenuContent, MenuContentItem } from '@models/interfaces/components/Menu.interface';
import { CommonModule } from '@angular/common';
import { MapViewerService } from '@3ddv/ngx-dvm-internal';
import { DvmService } from '@services/dvm.service';


@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.css'
})
export class MenuItemComponent {
  
  @Input({required: true})
  public item!: MenuContent;

  // SERVICES
  private readonly menuService:   MenuService             = inject(MenuService);
  private readonly dvm:           DvmService              = inject(DvmService); 
  public readonly  viewer:        MapViewerService        = this.dvm.viewer;
  
  // STATE
  public readonly  isSelected:    Signal<boolean>         = computed(():boolean => this.menuService.itemSelected()?.id === this.item.data.id);
  public           isOpen:        boolean                 = false;

  // GETTERS
  public get data(): MenuContent['data'] {
    return this.item.data;
  }

  public get hasChildren(): boolean {
    return !!(this.data.children && this.data.children.length > 0);
  }

  // METHODS
  public selectItem(): void {

    if(this.hasChildren) return this.toggleOpen();

    this.menuService.selectItem(this.item);
    
  }

  public onItemHover(item?: MenuContentItem): void {

    this.menuService.hoverMenuItem(item);

  }

  public onItemLeave(): void {

    this.menuService.leaveMenuItem();

  }

  protected onItemFocus(event: FocusEvent, item?: MenuContentItem): void {
    if (event.type === 'focus') {
      const from = event.relatedTarget as HTMLElement;

      // Only trigger hover if focus comes from the menu, not from outside, i.e: tab change
      if (!from) return;
      this.menuService.hoverMenuItem(item);
    }
  }

  private toggleOpen(): void {
    this.isOpen = !this.isOpen;
  }

}
